import { render, staticRenderFns } from "./updateloginpwd.vue?vue&type=template&id=c3832ca0"
import script from "./updateloginpwd.vue?vue&type=script&lang=ts"
export * from "./updateloginpwd.vue?vue&type=script&lang=ts"
import style0 from "./updateloginpwd.vue?vue&type=style&index=0&id=c3832ca0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports